module.exports = __webpack_public_path__ + "static/bottom-2844eb04cd48bd6d6962af90767b7da3.png";